import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Condition = ({ condition }: SpecProps<"condition">) => {
  const { i18n } = useLingui();

  if (!condition) {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.common.condition",
    message: "Condition",
    comment: "Field for 'condition' in ad specification",
  });
  return <FieldValuePair field={field} value={condition} />;
};
